import { FC } from 'react';
import { notionFaqUrl } from 'src/utils/constants/service-constants';

import { useTitle } from '../hooks/useTitle';

import NotionIframe from 'src/components/atoms/NotionIframe/NotionIframe';
import TopNavigationBar from 'src/components/atoms/TopNavigationBar/TopNavigationBar';

const FaqPage: FC = () => {
  useTitle('GU | 서비스 안내');
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <TopNavigationBar title='서비스 안내' leftButton />
      <NotionIframe uri={notionFaqUrl} />
    </div>
  );
};

export default FaqPage;
